/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionSortiePosition
 */
export interface InputUavMissionSortiePosition {
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionSortiePosition
     */
    dist?: number;
}

/**
 * Check if a given object implements the InputUavMissionSortiePosition interface.
 */
export function instanceOfInputUavMissionSortiePosition(value: object): boolean {
    return true;
}

export function InputUavMissionSortiePositionFromJSON(json: any): InputUavMissionSortiePosition {
    return InputUavMissionSortiePositionFromJSONTyped(json, false);
}

export function InputUavMissionSortiePositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionSortiePosition {
    if (json == null) {
        return json;
    }
    return {
        
        'dist': json['dist'] == null ? undefined : json['dist'],
    };
}

export function InputUavMissionSortiePositionToJSON(value?: InputUavMissionSortiePosition | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dist': value['dist'],
    };
}

